import { WidgetType } from "@codemirror/view";

export class ItemWidget extends WidgetType {
    constructor(currentEnvironment, ordinal, listDepth) {
        super();
        this.currentEnvironment = currentEnvironment;
        this.ordinal = ordinal;
        this.listDepth = listDepth;

        this.bullets = ["disc", "circle", "square"];
        this.numbers = ["decimal", "lower-alpha", "lower-roman", "upper-alpha"];

        if (currentEnvironment === "itemize") {
            this.listType = this.bullets[(listDepth - 1) % this.bullets.length];
            this.suffix = "' '";
        } else {
            this.listType = this.numbers[(listDepth - 1) % this.numbers.length];
            this.suffix = "'. '";
        }
    }

    toDOM() {
        const element = document.createElement("span");
        element.classList.add("ol-cm-item");
        element.textContent = " ";
        this.setProperties(element);
        return element;
    }

    eq(widget) {
        return (
            widget.currentEnvironment === this.currentEnvironment &&
            widget.ordinal === this.ordinal &&
            widget.listDepth === this.listDepth
        );
    }

    updateDOM(element) {
        this.setProperties(element);
        return true;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }

    setProperties(element) {
        element.style.setProperty("--list-depth", String(this.listDepth));
        element.style.setProperty("--list-ordinal", String(this.ordinal));
        element.style.setProperty("--list-type", this.listType);
        element.style.setProperty("--list-suffix", this.suffix);
    }
}
